import { mergeSx } from "@/utils/styleHelpers";
import type { ReactElement } from "react";

import type { BodyProps } from "@/types";
import { Body } from "../Text/Body/Body";

export type CardDescriptionProps<
  RC extends ReactElement | undefined = undefined,
> = BodyProps<RC>;

export function CardDescription<
  RC extends ReactElement | undefined = undefined,
>({
  size = "small",
  weight = "regular",
  sx,
  rc = <span />,
  className,
  ...props
}: CardDescriptionProps<RC>) {
  return (
    <Body
      {...props}
      className={`${className ?? ""} CardDescription`}
      sx={mergeSx(
        {
          color: "base.color.text.body.secondary",
          textAlign: "left",
        },
        sx,
      )}
      size={size}
      weight={weight}
      rc={rc}
    />
  );
}

CardDescription.displayName = "Card.Description";
